export class HolRoot {
  IsMessage: boolean;
  Messages: string[];
  Locations: HolLocation[];

  constructor() {
    this.IsMessage = false;
    this.Messages = [];
    this.Locations = [];
  }
}

export class HolLocationHour {
  DayOfWeek: string;
  Begin: string;
  End: string;

  constructor() {
    this.DayOfWeek = '';
    this.Begin = '';
    this.End = '';
  }
}

export class HolLocation {
  LocationId: string;
  CompanyName: string;
  StreetLine: string;
  City: string;
  State: string;
  Country: string;
  DistanceUnit: string;
  DistanceValue: string;
  SpecialInstruction: string;
  OpenHours: HolLocationHour[];

  constructor() {
    this.LocationId = '';
    this.CompanyName = '';
    this.StreetLine = '';
    this.City = '';
    this.State = '';
    this.Country = '';
    this.DistanceUnit = '';
    this.DistanceValue = '';
    this.SpecialInstruction = '';
    this.OpenHours = [];
  }
}
